import UserManagement from '@/pages/UserManagement';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

export default function UsersPage() {
  return (
    <ProtectedRoute requiredRole="admin">
      <UserManagement />
    </ProtectedRoute>
  );
}
